<template>
  <div class="container">
    <div class="row">
      <div class="col-12 ">
        <h3 class="page-heading">{{ pagetitle ? pagetitle : 'Coming Soon' }}</h3>
        <p v-if="pagetitle == 'Assets'">For the specific project</p>
      </div>
    </div>
    <div class="signup-content">
      <h3>COMING SOON</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComingSoon',
  computed: {
    pagetitle () {
      return this.$route.query.title
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/profile/ComingSoon.vue